import { createContext as t } from "../../../../external/preact/dist/preact.module.js";
import { useContext as o } from "../../../../external/preact/hooks/dist/hooks.module.js";
import { EMPTY_OBJECT as r } from "../../../../utils/value/constants.js";
const e = t(r), s = () => o(e);
export {
  e as DataGridContext,
  s as useDataGridContext
};
